<template>
  <router-view/>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  border:0
}
#app, body, html {
    height: 100%;
    width: 100%;
    color: #495057;
    font-size: 14px;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei","Helvetica Neue",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    font-variant: tabular-nums;
    line-height: 1.5;
    background-color: #fff;
    font-feature-settings: "tnum";
    min-width: 338px;
}
</style>
